import * as d3 from "./d3"
import { legend } from "./chartutils"

const formats = {
  comma: d3.format(","),
  commaRound: d3.format(",.0f"),
  commaRoundClipPositive: d => d3.format(",.0f")(Math.max(0, d)),
  renderDefault: d => d
}


export function geomap ({mapdata, mapConfig}) {
  const { el, width=975, height=610, toponame="counties",
    DATAROWKEY="COUNTYFIPS", PATHID="", color={}, tooltip } = mapConfig
  const colorScale = d3.scaleThreshold(
    color.domain || [-200, -20, -1, 1, 20, 200],
    // ['#1a9850', '#91cf60', '#d9ef8b', '#ffffbf', '#fee08b', '#fc8d59', '#d73027']
    color.range || ['#4575b4', '#91bfdb', '#e0f3f8', '#ffffbf', '#fee090', '#fc8d59', '#d73027']
  )
  const viewBox = [0, 0, width, height]
  const topo = d3.topojson.feature(mapdata, mapdata.objects[toponame])
  // d3.topojson.feature(mapdata, mapdata.objects.counties).features
  let path = d3.geoPath()
  if (toponame != "counties") {
    const projection = d3.geoMercator()
    path = path.projection(projection)
    // set bound view
    projection.fitSize([width, height], topo)
  }
  if (PATHID) {
    topo.features.map(d => d.id = d.properties[PATHID])
  }
  let states
  if ('states' in mapdata.objects)
    states = new Map(mapdata.objects.states.geometries.map(d => [d.id, d.properties]))

  const getColor = d => (d)?colorScale(d[1]):""
  const $el = d3.select(el)
  $el.html(`
  <div class="mapcontrols align-items-center border d-flex flex-column p-1 position-absolute">
    <div class="action" data-zoom="zoomin">&#65291;</div>
    <div class="action" data-zoom="reset">&#x21bb;</div>
    <div class="action" data-zoom="zoomout">&#65293;</div>
  </div>
  <svg>
  ${legend({color: colorScale, title: "Beds Shortage", tickSize: 0}).node().outerHTML}
  </svg>`)
  var mapZoom = d3.zoom().on("zoom", freeZoom)
  const svg = $el.select("svg").attr("viewBox", viewBox)
    .attr("preserveAspectRatio", "xMidYMin meet")
    .call(mapZoom)

  var map = svg.append('g')
    .attr('transform', `translate(0,0)`).attr('class', 'map')

  svg.select("g.legend").attr("transform", "translate(650,2)")
  svg.select("g.legend-axis").attr("font-size", 14)

  const dispatch = d3.dispatch('map_reset', 'map_zoomin', 'map_zoomout')

  $el.selectAll(".mapcontrols .action").on('click', function () {
    dispatch.call(`map_${this.dataset.zoom}`)
  })
  // map zoom
  function freeZoom() { map.attr("transform", d3.event.transform) }
  const zoomdelta = 0.5
  dispatch
    .on('map_reset', () => svg.transition().duration(500).call(mapZoom.transform, d3.zoomIdentity))
    .on('map_zoomin', () => mapZoom.scaleBy(svg.transition().duration(500), 1 + zoomdelta))
    .on('map_zoomout', () => mapZoom.scaleBy(svg.transition().duration(500), 1 - zoomdelta))

  const paths = map.append("g")
    .selectAll("path.path_1")
    .data(topo.features)
    .join("path")
      .attr("class", "path_1")
      .attr("d", path)
      .attr("fill", "#999")

  if (states) {
    map.append("path")
      .datum(d3.topojson.mesh(mapdata, mapdata.objects.states, (a, b) => a !== b))
      .attr("fill", "none")
      .attr("stroke", "white")
      .attr("stroke-width", 2)
      .attr("stroke-linejoin", "round")
      .attr("d", path)
  }

  const tip = new Tooltip({rootView: d3.select("body"), opts: {states, tooltip, x:25, y:-75}})

  function update({ data }) {
    data = new Map(
      data.map(d => [d[DATAROWKEY], [d["BEDS"], d["_p_diff"], d["Total Population"], d["_p_total"]]]),
      {title: ["beds", "beds needed", "Total Population", "Critical Population"]})
    paths.attr("fill", d => getColor(data.get(d.id)) )
      .on("click", d => console.log(d, data.get(d.id)))
      .on("mouseover", function (d) {
        tip.mouseover(d)
        d3.select(this).attr("stroke", "black")
      })
      .on("mouseout", function (d) {
        tip.mouseout(d)
        d3.select(this).attr("stroke", "none")
      })
      .on("mousemove", d => tip.mousemove(d, {data}))
  }
  return { svg, update }
}

export class Tooltip {
  constructor({rootView, opts={x: 20, y: -30}}) {
    this.opts = opts
    this.tooltip = rootView.append('div')
      .attr('class', 'dtooltip')
      .style('display', 'none')
  }
  mouseover() { this.tooltip.style('display', 'inline') }
  mouseout() { this.tooltip.style('display', 'none') }
  mousemove(d, config) {
    const content = this.tooltipHTML(d, config)
    if (!content) {
      this.mouseout()
      return
    }
    this.tooltip.html(content).styles(this.position())
  }
  position() {
    return {left: `${d3.event.pageX + this.opts.x}px`, top: `${d3.event.pageY + this.opts.y}px`}
  }
  tooltipHTML(d, config) {
    const { states, tooltip={} } = this.opts
    const { property_keys={key: "name", state: "state"} } = tooltip
    const { data } = config
    const metrics = data.get(d.id)
    const shortage = d => {
      if (d[0] == 0) {
        return `<span class="text-danger">${formats.commaRoundClipPositive(d[3])} Beds Shortage</span>`
      } else if (d[1] > 0) {
        return `<span class="text-danger">${formats.commaRoundClipPositive(d[1])} Beds Shortage</span>`
      }
      return `<span>No Beds Shortage</span>`
    }
    const summary = d => `
    <div class="py-1" style="min-width:170px;">
      <div class="d-flex justify-content-between"><span>Total Population</span><span>${formats.commaRound(metrics[2])}</span></div>
      <div class="d-flex justify-content-between"><span>Total Beds</span><span>${formats.commaRound(metrics[0])}</span></div>
      <div class="d-flex justify-content-between"><span>Critical Population</span><span>${formats.commaRound(metrics[3])}</span></div>
    </div>
    <div class="h6 my-1 text-uppercase">${shortage(metrics)}</div>`
    return `
    <div class="py-1 border-bottom">
      <span class="h5">${d.properties[property_keys.key]}</span><span> |
      ${d.properties[property_keys.state] || states.get(d.id.slice(0, 2)).name}</span>
      </div>
    ${metrics?summary():'No data'}
    `
  }
}

const default_table_columns = [
  {name: "State", column: "STNAME"},
  {name: "County", column: "CTYNAME"},
  {name: "Total Population", column: "Total Population", render: "commaRound", class: "text-right"},
  {name: "Beds (per/Mn)", column: "BEDSppm", render: "commaRound", class: "text-right"},
  {name: "Total Beds", column: "BEDS", render: "commaRound", class: "text-right"},
  {name: "Beds Needed", column: "_p_total", render: "commaRound", class: "text-right"},
  {name: "Beds Shortage", column: "_p_diff", render: "commaRoundClipPositive", class: "text-right"},
]

export function templateTable({ table, config={} }) {
  const { sortBy="_p_diff", order=1, columns=default_table_columns } = config
  const sorttag = (order==1)?"sortable desc":"sortable asc"
  const ordersort = (order==1)?"descending":"ascending"
  table = table.sort((a, b) => d3[ordersort](a[sortBy], b[sortBy]))  // .slice(0, 1000)
  const render = (row, col) => formats[col.render || "renderDefault"](row[col.column])
  return `
  <div class="overflow-auto table-wrapper small">
  <table class="table table-sm">
    <thead>
      <tr>
      ${columns.map(col => `
      <th class="${col.class || ''}" data-col="${col.column}" data-order="${order}" data-sort="${sortBy}">
        <div class="${(col.column==sortBy)?sorttag:''}">${col.name}</div>
      </th>`).join('')}
      </tr>
    </thead>
    <tbody>
      ${table.map(row => `
      <tr>
        ${columns.map(col => `
        <td class="${col.class || ''}">${render(row, col)}</td>
        `).join('')}
      </tr>
      `).join('')}
    </tbody>
  </table>
  </div>`
}

export function templateKPI({ d, config={} }) {
  const kpis = config.kpis || [
    {name: "Total Beds Available", value: "BEDS", format: "comma"},
    {name: "Critical Population", value: "TOTAL", format: "commaRound"},
    {name: "Local Beds Shortage", value: "SHORTFALL", format: "commaRound"},
    {name: "At Risk Counties", value: "PLACESATRISK", format: "comma"},
    {name: "At Risk Population", value: "POPATRISK", format: "commaRound"},
  ]
  return `${kpis.map(kpi => `
    <div class="kpi p-2">
      <div class="h6 text-uppercase mb-0">${kpi.name}</div>
      <div class="h3">${formats[kpi.format](d[kpi.value])}</div>
    </div>
    `).join('')}`
}
